import ReactDOM from 'react-dom/client';
import {BrowserRouter, Route, Routes,} from "react-router-dom";
import SignUp from "./pages/Sign-Up";
import SignIn from "./pages/Sign-In";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/404";
import Forbidden from "./pages/403";
import PrivateRoute from "./components/PrivateRoute";
import AdminDashboard from "./pages/AdminDashboard";
import Provider from "./components/Provider";
import './index.less';
import reportWebVitals from "./reportWebVitals";
import QuickSight from "./pages/QuickSight";
import Settings from "./pages/Settings";
import Upload from "./pages/Upload";
import AdminRoute from "./components/AdminRoute";
import VINsValidation from "./pages/VinsValidation";
import { message } from 'antd';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

message.config({
    duration: 15,
});

root.render(
    // <React.StrictMode>
    <Provider>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={
                    <PrivateRoute>
                        <Dashboard/>
                    </PrivateRoute>
                }>
                    <Route path={"/"} element={<QuickSight/>}/>
                    <Route path={"/settings"} element={<Settings/>}/>
                    <Route path={"/upload"} element={<Upload/>}/>
                    <Route path={"/vins-validation"} element={<VINsValidation />}/>
                    <Route path="/admin" element={
                        <AdminRoute>
                            <AdminDashboard/>
                        </AdminRoute>
                    }/>
                </Route>
                <Route path="/sign-in" element={<SignIn/>}/>
                <Route path="/sign-up" element={<SignUp/>}/>
                <Route path="/forbidden" element={<Forbidden/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </BrowserRouter>
    </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
